// @ts-nocheck

import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { UserClinicalCredentials } from '@core/model';
import { AuthenticationService } from '@core/authentication/services';

const EmailRegExp =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// TODO: remove after angular 21 migration of Notes.MFE
@Pipe({
  name: 'userProfileCredentialsByEmail',
  standalone: true
})
export class GetUserProfileCredentialsByEmailPipe implements PipeTransform {
  private authenticationService: AuthenticationService = inject(AuthenticationService);

  transform(value: string): Observable<string> {
    // Return a default observable when the condition is not met
    const invalidResult = of('Invalid email format or no value provided');

    if (!value) {
      return invalidResult;
    }

    // check if note is a system note
    if (value.toLowerCase() === 'portal') {
      return of(value);
    } else if (EmailRegExp.test(value)) {
      return this.authenticationService.getUserClinicalCredentialsByEmail(value).pipe(
        catchError(error => {
          console.error('Error fetching credentials', error);
          return of(value);
        }),
        map((data: UserClinicalCredentials) => {
          const createdBy = data.email || '';
          if (data.isExternal) return createdBy;
          return data?.firstName || data?.lastName
            ? `${data.firstName} ${data.lastName}${data.credentials ? ',' : ''} ${data.credentials || ''}`.trim()
            : createdBy;
        })
      );
    } else {
      return invalidResult;
    }
  }
}
